import { combineReducers } from 'redux';
import answers from './form/answer-list/reducers/answer';
import formList from './form/form-management/reducers/form';
import workflow from './form/answer-list/reducers/form';

export default combineReducers({
  answers, formList, workflow
});
